import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import ExtraLuggageSummary from '../../../../elements/summary/shared/ExtraLuggageSummary'
import FlexibleRebookingSummary from '../../../../elements/summary/shared/FlexibleRebookingSummary'
import HandLuggageSummary from '../../../../elements/summary/shared/HandLuggageSumary'
import PrivateRoomSummary from '../../../../elements/summary/shared/PrivateRoomSummary'

import { AppState } from '../../../../data/state'

interface TotmExtrasSummaryProps {
  surfLessonsEasy: number
  surfLessonsHard: number
}

const TotmExtrasSummary: React.FC<TotmExtrasSummaryProps> = props => {
  return (
    <>
      <HandLuggageSummary />
      <ExtraLuggageSummary />
      <PrivateRoomSummary />
      <ListItem>
        <DisplayContent
          contentKey="surfNBeach-easy-lessons-summary"
          vars={{ number: props.surfLessonsEasy.toString() }}
        >
          {`${props.surfLessonsEasy}x Easy Surf Lessons`}
        </DisplayContent>
      </ListItem>
      <ListItem>
        <DisplayContent
          contentKey="surfNBeach-hard-lessons-summary"
          vars={{ number: props.surfLessonsHard.toString() }}
        >
          {`${props.surfLessonsHard}x Experienced Surf Lessons`}
        </DisplayContent>
      </ListItem>
      <FlexibleRebookingSummary />
    </>
  )
}

export default connect((state: AppState) => ({
  surfLessonsEasy: state.funnelOrder.totmOrder.surfLessonsEasy,
  surfLessonsHard: state.funnelOrder.totmOrder.surfLessonsHard,
}))(TotmExtrasSummary)
